import { render, staticRenderFns } from "./el-enroll-info.vue?vue&type=template&id=5641e1c6&lang=pug"
import script from "./el-enroll-info.vue?vue&type=script&lang=js"
export * from "./el-enroll-info.vue?vue&type=script&lang=js"
import style0 from "./el-enroll-info.vue?vue&type=style&index=0&id=5641e1c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports